export const RQ_GET_LEAVE_REPORTS_API = {
  url:'leaves/data-list/<%= locationId %>/<%= year %>',
  method:'GET',
  auth:true,
};
